import { Modal } from 'bootstrap'
import { spanAttribute, selectedAttribute, drawBeamSpan, drawSupport, drawDistributedLoad, drawLinearLoad, drawPointLoad, drawMomentLoad } from './graphics/graphics.js'
import { showFeetInches } from './units/units.js';
import { openUniformLoadDialog, openLinearLoadDialog, openMomentLoadDialog, openPointLoadDialog } from './components/main-ui/load-editor-dialog-component.js'

const beamCanvas = Raphael("beam-model-view", document.getElementById("beam-model-view").offsetWidth, 300)
const beamPaper = beamCanvas

//var beamCanvas;
var canvasRect = [600, 260];
var beam_t = 25;
var beam_y = canvasRect[1] - 125;

var debug = false;

function getScale(modelWidth, modelHeight, paperRect) {
  const width = modelWidth //200
  const height = modelHeight //200

  // we want the model to fit in the canvas. we scale it so that it is 
  // either x% the width or x% the height depending on the aspect ratio
  // if w > h -> aspect w/h > 1.0 fit the model to the height
  // if w < h -> aspect w/h < 1.0 fit the model to the width

  const paperAspect = paperRect[0] / paperRect[1]
  const modelAspect = width / height

  if(paperAspect > 1.0 && modelAspect > 1.0) { return paperRect[0] / width * 0.80 }
  if(paperAspect < 1.0 && modelAspect > 1.0) { return paperRect[0] / width * 0.80 }
  if(paperAspect > 1.0 && modelAspect < 1.0) { return paperRect[1] / height * 0.80 }
  if(paperAspect < 1.0 && modelAspect < 1.0) { return paperRect[1] / height * 0.80 }
  return paperAspect < 1.0 ? paperRect[0] / width * 0.80 : paperRect[1] / height * 0.80
}

export function redrawCanvas(beam) {
  if(beamPaper && beam) {
    beamPaper.clear();
    drawBeamModel(beam);
  }
}

function drawBeamModel(beam) {
  const canvasW = document.getElementById("beam-model-view").offsetWidth
  const canvasH = document.getElementById("beam-model-view").offsetHeight
  const canvasRect = [canvasW, canvasH]

  const beamLength = beam.totalLength() ; // inches
  const beamHeight = beamLength * 0.25 // inches
  const scale = getScale(beamLength, beamHeight, canvasRect)

  var totalLength = beam.totalLength();
  const x_scale = scale
  const x_start = canvasRect[0] * 0.5 - totalLength * x_scale * 0.5;
  
  var spanDomElements = [];
  const onBeamClick = () => Modal.getOrCreateInstance(document.getElementById('span-dialog')).show()
  for (var i = 0; i < beam.nodes.length - 1; i++) {
    var x1 = x_start + x_scale * beam.nodes[i].x;
    var x2 = x_start + x_scale * beam.nodes[i + 1].x;
    var dist = beam.nodes[i + 1].x - beam.nodes[i].x;
    spanDomElements.push(drawBeamSpan(x1, x2, beam_y, beam_y + beam_t, showFeetInches(dist), beamCanvas, onBeamClick))
  }
  //now make hover over one dom element select them all...
  for (var i = 0; i < spanDomElements.length; i++) {
    var self = spanDomElements[i];
    self.node.onmouseover = () => {
      self.node.style.cursor = 'pointer';
      for (var j = 0; j < spanDomElements.length; j++) {
        spanDomElements[j].attr(selectedAttribute);
      }
    }
    self.node.onmouseout = () => {
      for (var j = 0; j < spanDomElements.length; j++) {
        spanDomElements[j].attr(spanAttribute);
      }
    }
  }

  for (let i = 0; i < beam.nodes.length; i++) {
    const x1 = x_start + x_scale * beam.nodes[i].x;
    const support = beam.nodes[i].support;
    const onclick = () => beam.cycleSupport(i)
    drawSupport(support, x1, beam_y + beam_t, beam_t, beamCanvas, onclick);
  }

  const dist_load_arrow_shaft = 35;

  /* Loads */
  //arrange distributed loads
  var load_y = []
  for (var i = 0; i < beam.distLoads.length; i++) {
    var y = beam_y;
    for (var j = 0; j < i; j++) {
      if (beam.distLoads[j].Overlaps(beam.distLoads[i])) y -= dist_load_arrow_shaft;
    }
    load_y.push(y);
  }
  //now draw them so that labels don't get covered up
  for (var i = beam.distLoads.length - 1; i >= 0; i--) {
    const index = i
    var x1 = x_start + x_scale * beam.distLoads[i].x1;
    var x2 = x_start + x_scale * beam.distLoads[i].x2;
    var l = beam.distLoads[i].Label("k/ft");
    for (var j = 0; j < i; j++) {
      if (beam.distLoads[j].Overlaps(beam.distLoads[i])) y -= dist_load_arrow_shaft;
    }
    var y = beam_y;
    if (load_y[i]) y = load_y[i];
    if (beam.distLoads[i].isLinear) {
      const onLoadClick = () => openLinearLoadDialog(index)
      drawLinearLoad(beam.distLoads[i].D, beam.distLoads[i].D2, x1, x2, y, y, l, beamCanvas, onLoadClick);
    } else {
      const onLoadClick = () => openUniformLoadDialog(index)
      drawDistributedLoad(beam.distLoads[i].direction(), x1, x2, y, l, beamCanvas, onLoadClick)
    }
  }
  for (var i = 0; i < beam.pointLoads.length; i++) {
    const index = i
    var x1 = x_start + x_scale * beam.pointLoads[i].x;
    if (beam.pointLoads[i].isMoment) {
      var l = beam.pointLoads[i].Label("kip-ft");
      const onLoadClick = () => openMomentLoadDialog(index)
      drawMomentLoad(x1, beam_y, beam_t, l, beamCanvas, onLoadClick);
    } else {
      var l = beam.pointLoads[i].Label("kips");
      const onLoadClick = () => openPointLoadDialog(index)
      drawPointLoad(beam.pointLoads[i].direction(), x1, beam_y, l, beamCanvas, onLoadClick);
    }
  }
}
